// connect sanity with our react application

// import sanityClient from '@sanity/client'
import {createClient} from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

export const client = createClient({
    projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
    dataset: 'production',
    apiVersion: '2023-06-26',
    useCdn: true,
    token: process.env.REACT_APP_SANITY_TOKEN
})

// below code will always provided when working with image using sanity
const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source)